import React, { ReactElement } from 'react'
import StatisticsRowItem from '../RowItem/StatisticsRowItem'
import RowFont from '../RowFont'
import { RowItemProps } from '../RowItem'

type Props = {
    againstValue: string | number
    forValue: string | number
    width: number | number[]
} & Pick<RowItemProps, 'display'>

const DifferenceDetail = ({
    againstValue,
    forValue,
    width,
    display = ['none', 'none', 'flex'],
}: Props): ReactElement | null => {
    return (
        <StatisticsRowItem display={display} width={width}>
            <RowFont>{`${forValue}:${againstValue}`}</RowFont>
        </StatisticsRowItem>
    )
}

export default DifferenceDetail
